import { partition } from 'lodash'
import ProjectTransitionAsset from '~/models/ProjectData/ProjectTransitionAsset'

export const correctAssets = assets => {
  const [ assetsWithoutTransitions, transitions ] = partition(assets,
    a => !(a instanceof ProjectTransitionAsset))
  const correctedAssets = [ ...assets ]
  assetsWithoutTransitions.forEach((asset, i, array) => {
    const prevAsset = array[i - 1]
    const prevAssetEndTime = prevAsset
      ? prevAsset.startTime + prevAsset.duration
      : 0
    if (asset.startTime < prevAssetEndTime) {
      // eslint-disable-next-line no-param-reassign
      asset.startTime = prevAssetEndTime
    }
    const transitionWithRightAsset = transitions.find(t => t.isAttachedToRight(asset.id))
    if (transitionWithRightAsset?.isMountBetween) {
      // eslint-disable-next-line no-param-reassign
      asset.startTime -= transitionWithRightAsset.duration
    }
  })
  transitions.forEach(t => {
    const transitionAssetLeft = assetsWithoutTransitions.find(a => t.isAttachedToLeft(a.id))
    const transitionAssetRight = assetsWithoutTransitions.find(a => t.isAttachedToRight(a.id)
      && t.isMountIn)
    if (transitionAssetLeft) {
      // eslint-disable-next-line no-param-reassign
      t.startTime = transitionAssetLeft.startTime + transitionAssetLeft.duration - t.duration
    } else if (transitionAssetRight) {
      // eslint-disable-next-line no-param-reassign
      t.startTime = transitionAssetRight.startTime
    }
  })
  return correctedAssets
}
